import { DatePicker, Space } from "antd";
import BaseListPage from "../../base/BaseListPage";
import { formatDate } from "./Converter";

export default class DateRangePicker extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  async onChange(date, dateString) {
    const { fields, isArray } = this.props;
    const employeeID = this.getCurrentUser().employee.id;

    const [startDateField, endDateField, employeeField] = fields;
    let where = {};

    if (isArray) {
      if (dateString[0] && dateString[1]) {
        where = {
          [startDateField]: {
            $elemMatch: {
              $gte: dateString[0],
              $lte: dateString[1],
            },
          },
          // ...(employeeField && { [employeeField]: employeeID }),
        };
      }
    } else if (fields[1] === "") {
      where = {
        ...(dateString[0] && {
          [startDateField]: {
            $gte: formatDate(dateString[0]),
            $lte: formatDate(dateString[1]),
          },
        }),
      };
    } else {
      if (dateString[0] !== "" && dateString[1] !== "") {
        where = {
          ...(dateString[0] && { [startDateField]: { $gte: dateString[0] } }),
          ...(dateString[1] && { [endDateField]: { $lte: dateString[1] } }),
          ...(employeeField && { [employeeField]: employeeID }),
        };
      }
    }
    try {
      // console.log("WHERE: ", where);
      this.props.onFilter(where);
    } catch (error) {
      console.error("Error fetching objects: ", error);
    }
  }

  render() {
    const { RangePicker } = DatePicker;
    const { width } = this.props;

    return (
      <>
        <style>
          {`
            .custom-range-picker .ant-picker-input input::placeholder {
              color: grey;
              opacity: 1;
            }
          `}
        </style>
        <div style={width ? { width } : {}}>
          <Space direction="vertical" size={20} style={{ width: "100%" }}>
            <RangePicker
              onChange={this.onChange.bind(this)}
              className="custom-range-picker border p-2 fw-semibold"
              style={{ width: "100%" }}
            />
          </Space>
        </div>
      </>
    );
  }
}
